<template>
  <div class="service-categories" :class="{ 'no-top-padding': isMobileApp }">
    <Banner page="booking_services_index_page" />
    <ListingCardContainer>
      <ListingCard v-for="category in includedCategories" :key="category.id">
        <ListingCardItem
          :title="category.attributes.name"
          :description="category.attributes.description"
          :image-src="category.attributes.image"
          :is-web="isWeb"
          :router-link="{ name: 'booking-service-category-show', params: { id: category.attributes['slug-url'] }}"
          :button-text="$t('buttons.moreDetails')"
        >
          <template v-slot:description>
            <div class="description" v-html="category.attributes.description" />
          </template>
        </ListingCardItem>
      </ListingCard>
    </ListingCardContainer>
  </div>
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "metaDescription": "Discover beauty and makeup services with our expert Beauty Advisors at the Sephora Beauty Studio. Approach any of our in-store Beauty Advisors or book an appointment online now!"
    }
  },
  "lng_id": {
    "bookingService": {
      "metaDescription": "Discover beauty and makeup services with our expert Beauty Advisors at the Sephora Beauty Studio. Approach any of our in-store Beauty Advisors or book an appointment online now!"
    }
  },
  "lng_zh": {
    "bookingService": {
      "metaDescription": "Discover beauty and makeup services with our expert Beauty Advisors at the Sephora Beauty Studio. Approach any of our in-store Beauty Advisors or book an appointment online now!"
    }
  },
  "lng_th": {
    "bookingService": {
      "metaDescription": "Discover beauty and makeup services with our expert Beauty Advisors at the Sephora Beauty Studio. Approach any of our in-store Beauty Advisors or book an appointment online now!"
    }
  },
  "lng_ko": {
    "bookingService": {
      "metaDescription": "세포라 뷰티 스튜디오에서 뷰티 어드바이저의 뷰티 및 메이크업 서비스를 경험해보세요. 매장에서 뷰티 어드바이저를 찾으시거나 지금 온라인에서 서비스를 예약하세요! "
    }
  }
}
</i18n>

<script>
import { mapGetters, createNamespacedHelpers } from 'vuex'
import { serviceProviders } from '@/modules/config/booking-services'
import Banner from './reusable/banner.vue'
import ListingCard from './ListingCard.vue'
import ListingCardContainer from './ListingCardContainer.vue'
import ListingCardItem from './ListingCardItem.vue'
import { fullUrl } from '@/modules/services/utilities'
import { setCookie } from '@/modules/services/cookies'

const { mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'ServiceCategory',
  components: {
    Banner,
    ListingCard,
    ListingCardContainer,
    ListingCardItem
  },

  computed: {
    ...mapState(['categories']),
    ...mapGetters(['isMobileApp', 'isWeb']),
    ...mapGetters('bookingService', ['objectById']),
    includedCategories () {
      const locationId = this.$route.query.locationId

      const filteredCategories = this.categories.filter(category => {
        const matchesInHouseCriteria =
          category.attributes['booking-vendor'] === 'In House' &&
          category.attributes['cutover-from'] === null &&
          category.attributes['cutover-till'] === null
        const isNotService = category.attributes['activity-type'] !== 'Service'
        const isPublished = category.attributes['status'] === 'published'
        return !(matchesInHouseCriteria || isNotService) && isPublished
      })

      if (locationId) {
        const locationMatchedCategories = filteredCategories.filter(category =>
          category.attributes['store-ids'].includes(locationId)
        )

        if (locationMatchedCategories.length > 0) {
          return locationMatchedCategories
        }
      }

      return filteredCategories
    }
  },

  created () {
    this.storeQueryParamsInCookies()
  },

  mounted () {
    this.initializeButtonStates()
    this.$store.commit('setSeoMetaTitle', this.$t('retailStore.services'))
    this.$store.commit('setSeoMetaDescription', this.$t('bookingService.metaDescription'))
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },

  methods: {
    storeQueryParamsInCookies () {
      const params = this.$route.query
      const paramsToStore = ['firstAvailable', 'locationId']

      paramsToStore.forEach(param => {
        if (params[param]) {
          const expiryTime = new Date(Date.now() + 5 * 60 * 1000)
          setCookie(param, params[param], expiryTime, '/')
        }
      })
    },
    gotoCategory (category) {
      this.$router.push({ name: 'booking-service-category-show', params: { id: category.attributes['slug-url'] } })
    },
    service (category) {
      if (serviceProviders.personalshopping === category.attributes['timetrade-workflow']) {
        return category.relationships.services.data.map(svc => this.objectById('activities', svc.id))[0]
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.service-categories {
  @include media-breakpoint-down(md) {
    padding-right: 5px;
    padding-left: 5px;
  }

  @include media-breakpoint-down(sm) {
    padding: 10px;
  }

  &.no-top-padding {
    padding-top: 0;
  }
}
</style>
